import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

/**
 * Custom hook to scroll the usage container to top on dependency changes.
 * @param {Object} params
 * @param {Object} params.usageContainerRef - Ref to the usage container element.
 * @param {any} params.currentActivity
 * @param {any} params.isPriceOverride
 * @param {any} params.showReportPayment
 * @param {any} params.showUnidInfoScreen
 * @param {any} params.showORreportScreen
 * @param {any} params.reportPaymentScreenName
 */
export function useScrollToTopEffect({
    usageContainerRef,
    currentActivity,
    isPriceOverride,
    showReportPayment,
    showUnidInfoScreen,
    showORreportScreen,
    reportPaymentScreenName,
}) {
    useEffectWithErrorLogging(() => {
        usageContainerRef.current?.scrollTo(0, 0);
    }, [
        currentActivity,
        isPriceOverride,
        showReportPayment,
        showUnidInfoScreen,
        showORreportScreen,
        reportPaymentScreenName,
    ]);
}
